import block from 'bem-cn-lite';
import React, {FC, ReactNode, useCallback, useState} from 'react';

import './index.scss';

const b = block('research-cut');

interface ResearchCutProps {
  header: ReactNode;
  className?: string;
  initialState?: boolean;
  state?: boolean;
  onStateChange?: (state: boolean) => void;
  children?: ReactNode;
}

const ResearchCut: FC<ResearchCutProps> = ({
  className,
  initialState,
  state,
  onStateChange,
  header,
  children,
}) => {
  const [localState, setLocalState] = useState(initialState ?? false);
  const curState = state ?? localState;
  const setCurState = typeof state === 'undefined' ? setLocalState : onStateChange;

  const handleClick = useCallback(() => {
    if (setCurState) setCurState(!curState);
  }, [curState, setCurState]);

  return (
    <div className={b(null, className)}>
      <h3
        className={b('header', {visible: curState})}
        onClick={handleClick}
        role="button"
        aria-expanded={curState}
      >
        {header}
      </h3>
      {curState && children}
    </div>
  );
};

export default ResearchCut;
